import { Container, Paper } from "@mui/material";
import { StatusView } from "../components/StatusView";

export function NotFoundPage() {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 2, sm: 6 } }}>
      <Paper elevation={3} sx={{ p: { xs: 3, sm: 5 } }}>
        <StatusView
          status="session_invalid"
          message="El link no es válido. Verificá la URL o pedí al comercio un nuevo link de pago."
        />
      </Paper>
    </Container>
  );
}
